import './table.less';
import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classname';
import { Link } from 'react-router';
import moment from 'moment';
import noop from 'lodash/noop';

const Table = ({
	table,
	intl,
	sortByColumn,
	managers,
	showAffiliatedDistributionPopup,
	showMoreRows,
	toggleAffiliateDistributionPopup,
	remove,
	can
}) => (
	<div className="table-container table-container--projector admin-list-table">
		<div className="table-container--projector__body">
			<div className="table-container--projector__body-content">
				<table className="simple-table simple-table--static">
					<thead className="simple-table__head font-roboto-medium">
						<tr>
							{ table.headers.map((header, i) => (
								<th
									key={i}
									className={cn({
										'sort-header': header.direction,
										'active': table.sortedColumn.index === header.index,
										[header.className]: header.className,
										[table.sortedColumn.direction]: (
											table.sortedColumn.index === header.index && table.sortedColumn.direction
										)
									})}
									onClick={() => header.direction ? sortByColumn(header.index) : noop}>{intl(header.title)}</th>
							))}
						</tr>
					</thead>

					<tbody className="simple-table__body">
						{ table.rows.map((row, i) => (
							<tr key={i}>
								<td className="id"><span>{ row.id }</span></td>
								<td className="email"><span>{ row.email }</span></td>
								<td className="datetime">
									<span className="date">{ moment(row.created_at).format('DD.MM.YYYY') }</span>
									<span className="at">{intl('at')}</span>
									<span className="time">{ moment(row.created_at).format('HH:mm') }</span>
								</td>
								<td className="datetime">
									<span className="date">{ moment(row.updated_at).format('DD.MM.YYYY') }</span>
									<span className="at">{intl('at')}</span>
									<span className="time">{ moment(row.updated_at).format('HH:mm') }</span>
								</td>
								<td className="is-manager">
									<span>{ intl(row.is_manager ? 'yes' : 'no') }</span>
								</td>
								<td className="actions">
									{ can('view') && (
										<Link to={`admins/edit/${row.id}`} className="action_edit" />
									) }

									{ can('delete') && (
										<a
											href="#"
											onClick={e => {
												e.preventDefault();
												if (!confirm(`${intl('Remove admin')} ${row.email}?`))
													return;
												remove(row.id);
											}} className="action_delete" />

									) }
								</td>
							</tr>
						)) }
					</tbody>
				</table>
			</div>
		</div>

		<div className="table-container__navigation">
			{ table.totalRows > table.rowsNumber && (
				<button className="ui-btn ui-btn-secondary" onClick={() => showMoreRows()}>{intl('Show more')}</button>
			)}
		</div>
	</div>
);

Table.propTypes = {
	table: PropTypes.object,
	managers: PropTypes.array,
	showAffiliatedDistributionPopup: PropTypes.bool,
	intl: PropTypes.func,
	sortByColumn: PropTypes.func,
	showMoreRows: PropTypes.func,
	remove: PropTypes.func,
	can: PropTypes.func
};

export default Table;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/admins/components/table.js